import { Box, Divider } from '@mui/material';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { MaritimeRequesterInfo, OrderInfo } from 'adoms-common-lib';
import React from 'react';
import InfoRow from '../atoms/InfoRow';

type MaritimeOrderRequesterInfoProps = {
    order: OrderInfo | undefined;
}

/**
 * 受け取り人情報を表示する
 * @param props order
 */
export const MaritimeOrderRequesterInfo: React.FC<MaritimeOrderRequesterInfoProps> = (props) => {
    const maritimeRequesterInfo = props.order?.requester as MaritimeRequesterInfo;

    const displayValue = (value: string | undefined) => (value && value !== '' ? value : 'ー');

    const renderUnitInfo = (label: string, unit: any) => {
        const unitName = displayValue(unit?.unitName);
        const lastName = displayValue(unit?.lastname);
        const firstName = displayValue(unit?.firstname);
        const mail = displayValue(unit?.mailaddress);
        const tel = displayValue(unit?.tel);

        return (
            <Box sx={{ width: '100%' }}>
                <Typography variant="subtitle1" textAlign="left" color="primary" fontWeight="bold" sx={{ mb: 1 }}>
                    {label}
                </Typography>
                <Box sx={{ textAlign: 'left' }}>
                    <InfoRow label="部隊名" value={unitName} />
                    <InfoRow label="担当者" value={`${lastName} ${firstName}様`} />
                    <InfoRow label="メールアドレス" value={mail} />
                    <InfoRow label="電話番号" value={tel} />
                </Box>
            </Box>
        );
    };

    return (
        <Paper sx={{
            textAlign: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%',
        }} elevation={0}>
            {renderUnitInfo('補給本部', maritimeRequesterInfo?.supplyHeadquartersInfo)}
            <Divider sx={{ my: 2 }} />
            {renderUnitInfo('補給元部隊', maritimeRequesterInfo?.supplySourceUnitInfo)}
        </Paper>
    );

}